import type { UUID } from "@/core/types";

export const noteKeys = {
  addendums: (noteId: UUID) => [...noteKeys.base, noteId, "addendums"] as const,
  base: ["note"] as const,
  details: (noteId: UUID) => [...noteKeys.base, noteId, "details"] as const,
  summary: (patientId: UUID) => [...noteKeys.base, patientId, "summary"] as const,
} as const;
